import { forwardRef, memo } from "react"

import type { HelpCenterArticleVersion } from "@productlane/zero"
import { NucleoFillIcon, Textarea } from "@productlane/ui"

import { DefaultEditor } from "@/components/editor/default-editor"

interface ArticlePreviewProps {
	version: HelpCenterArticleVersion
}

export const ArticlePreview = memo(
	forwardRef<HTMLDivElement, ArticlePreviewProps>(({ version }, ref) => {
		return (
			<div
				className="flex w-full flex-col items-center py-5 sm:py-10"
				ref={ref}
			>
				<div className="mx-auto flex max-w-full flex-1 flex-col px-5 sm:px-10 lg:max-w-[710px]">
					<div>
						<div className="flex items-center gap-2">
							<NucleoFillIcon icon={version.icon} className="h-5 w-5" />
						</div>
						<Textarea
							name="title"
							value={version.title || "Untitled"}
							variant="borderless"
							noResize
							textSize="xxl"
							placeholder="Title"
							className="no-scrollbar mb-2 mt-2 w-full bg-transparent"
							readOnly
							fontWeight="bold"
							maxLength={200}
						/>
						<Textarea
							name="summary"
							value={version.summary ?? ""}
							variant="borderless"
							noResize
							textSize="md"
							placeholder="Summary"
							className="mb-7 flex w-full flex-col bg-transparent text-gray-600 dark:text-gray-350"
							readOnly
							maxLength={300}
						/>
						{version.imageUrl && (
							<div className="mt-7">
								<img
									src={version.imageUrl}
									alt="Article cover"
									className="w-full rounded-lg ring-1 ring-black/20 dark:ring-white/20"
								/>
							</div>
						)}
					</div>

					<DefaultEditor
						autofocus={false}
						initialContent={version.content}
						placeholder=""
						onUpdate={() => {
							// Read-only, no updates
						}}
						editable={false}
						className="mt-8 w-full max-w-[min(630px,100%)] flex-grow pb-32"
						key={version.id}
					/>
				</div>
			</div>
		)
	}),
)

ArticlePreview.displayName = "ArticlePreview"
